import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1 - Logo + Quote */}
        <div className="footer-column">
          <h2 className="footer-logo">
            <span className="mbr">MBR</span>
            <br />
            <span className="networks">Network's</span>
          </h2>
          <p className="footer-quote">
            “Empowering every student to step confidently into their dream
            career.”
          </p>
        </div>

        {/* Column 2 - Services */}
        <div className="footer-column">
          <h3>Our Services</h3>
          <ul>
            <li>Career Guidance & Resume Building</li>
            <li>Interview Preparation</li>
            <li>Job & Internship Assistance</li>
            <li>HR & Recruiter Network</li>
            <li>AI Tools for Smarter Job Search</li>
          </ul>
        </div>

        {/* Column 3 - Navigation Links */}
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Column 4 - Social Media */}
        <div className="footer-column">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              Instagram
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              Facebook
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              Twitter
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} MBR Network's. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
